import axios, { AxiosRequestConfig } from "axios";
import { CustomerPaymentProvider } from "../models/CustomerPaymentProvider";
import { PaymentProvider } from "../models/PaymentProvider";
import { UUID } from "../utils";
import getErrorDetails from "./helpers/getErrorDetails";
import { List } from "./helpers/pagination";

export type GetCustomerPaymentProviders = (
  customerId: UUID,
  options?: AxiosRequestConfig
) => Promise<List<CustomerPaymentProvider>>;

export type PutCustomerPaymentProviders = (
  customerId: UUID,
  providerId: UUID,
  data:
    | Pick<PaymentProvider, "active" | "requiredOnboarding">
    | Pick<PaymentProvider, "active">,
  options?: AxiosRequestConfig
) => Promise<List<CustomerPaymentProvider>>;

export const getCustomerPaymentProviders: GetCustomerPaymentProviders = async (
  customerId,
  options
) => {
  try {
    const response = await axios.get<CustomerPaymentProvider[]>(
      `/customers/${customerId}/providers/payments`,
      options
    );
    const { data = [] } = response;

    return {
      list: data.map((paymentProvider) => {
        return { ...paymentProvider, customerId };
      }),
    } as List<CustomerPaymentProvider>;
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const putCustomerPaymentProviders: PutCustomerPaymentProviders = async (
  customerId,
  providerId,
  config,
  options
) => {
  try {
    await axios.put<CustomerPaymentProvider>(
      `/customers/${customerId}/providers/${providerId}/payments`,
      config,
      options
    );

    return getCustomerPaymentProviders(customerId, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};
